import * as React from 'react'
import { Container, IAppState } from '../Container';
import { ContactUs, CopyrightFooter } from 'app/components';
import * as ReactHighcharts from 'react-highcharts'
import { Button, FormControl, Row, Col } from 'react-bootstrap';
import { AssetsAndGrants, IStateOption } from 'app/components/visualizations/AssetsAndGrants';
import { DataAsOf } from 'app/components/visualizations/DataAsOf';
import { AssetAndGrantsTable } from 'app/components/visualizations/AssetAndGrantsTable';

interface IAssetsAndGrantsState {
  city: string
  state: IStateOption
  county: string
  zip: string
  dateStart: string
  dateEnd: Date
  stateData: IStateData[]
  cities: string[]
  states: any[]
  counties: string[]
  decemberDates: string[]
  stateLabel?: string
}

interface IStateData {
  id: string
  stateLabel: string
  county: string
  city: string
}

export class AssetsAndGrantsContainer extends Container<{}, IAssetsAndGrantsState> {
  state: IAssetsAndGrantsState = {
    city: '',
    state: { id: '', stateLabel: '' },
    county: '',
    zip: '',
    dateStart: '',
    dateEnd: undefined,
    stateData: [],
    stateLabel: '',
    cities: [],
    states: [],
    counties: [],
    decemberDates: [],
  }

  mapAppStateToContainerState(appState: IAppState): IAssetsAndGrantsState {
    return {
      city: '',
      state: { id: '', stateLabel: '' },
      county: '',
      zip: '',
      dateStart: '',
      stateLabel: '',
      dateEnd: undefined,
      stateData: [],
      cities: [],
      states: [],
      counties: [],
      decemberDates: [],
    }
  }

  componentWillMount() {

  }

  onFilterChange(filter) {
    this.setState({ state: filter.state, city: filter.city, county: filter.county, zip: filter.zip, dateStart: filter.dateStart, stateLabel: filter.stateLabel })
  }

  render() {
    const { city, state, county, zip, dateStart, stateLabel } = this.state
    ReactHighcharts.Highcharts.setOptions(
      {
        lang: {
          thousandsSep: ','
        }
      });
    return (
      <section>
        <section className="container margin-bottom" style={{ overflowX: 'hidden' }}>
          <section className="animated fadeIn">
            <header className="margin-bottom">
              <h2 className="hidden-xs">
                Assets and Grantmaking Trends
              </h2>
              <h3 className="visible-xs">Assets and Grantmaking Trends</h3>
              <p>The chart below illustrates the development of foundation assets and grantmaking over time for U.S. foundations nationally as well as by region. The chart uses historical data when available and estimates for periods for which filings have yet to be received.  Data is updated monthly as it is received. </p>
            </header>
            <DataAsOf />
            <section>
              <AssetsAndGrants displayFilters displayAssets displayGrants onChange={this.onFilterChange.bind(this)} />
              <header></header>
              <AssetAndGrantsTable state={state} county={county} city={city} zip={zip} dateStart={dateStart} stateLabel={stateLabel} />
            </section>
          </section>
        </section >
        <footer className="margin-y-xl">
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/AssetsAndGrantsContainer/index.tsx